import React from "react";
import "./Carrers.scss";

const Carrers = () => {
  return (
    <div>
      <h2>Careers</h2>
    </div>
  );
};
export default Carrers;
